import React, { useEffect, useState } from "react";
import "./showsScreen.css";
import { useSearchParams } from "react-router-dom";
import Showcard from "../../../components/Showcard/Showcard";
import { service } from "../../../Network/Home/Service";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";
function ShowsScreen() {
  const history = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [sliceCount, setSliceCount] = useState(12);
  const [downArrow, setDownArrow] = useState(true);
  const [showsList, setShowsList] = useState([]);
  const [data, setData] = useState(null);

  const slice = showsList.slice(0, sliceCount);
  useEffect(() => {
    if (sliceCount >= showsList.length) {
      setDownArrow(false);
    } else {
      setDownArrow(true);
    }
  }, [sliceCount, showsList]);

  const loadMore = () => {
    setSliceCount(sliceCount + 12);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    var singleObj = [];
    service
      .showsByCategory(searchParams.get("ID") ? searchParams.get("ID") : 714)
      .then((response) => {
        setLoading(false);
        if (response.success == true && response.data) {
          setData(response.data);
          const shows = response.data.shows || [];
          shows.map((item) => {
            singleObj.push(item);
          });

          setShowsList(singleObj);
        }
      });
  }, []);

  const listShows = () => {
    return slice.map((item, key) => (
      <li
        key={key}
        onClick={() => {
          if (item && item.video_id) {
            history({
              pathname: "/player",
              search: encodeURI(`video_ID=${item.video_id}`),
            });
          } else {
            history({
              pathname: "/show",
              search: encodeURI(`show_id=${item.show_id}`),
            });
          }
        }}
      >    
      <Showcard
            item={item}
            cardHover={true}
            key={key}
            metaData={true}
            imageUrl={`https://gizmeon.mdc.akamaized.net/thumbnails/thumbnails/` + item.logo_thumb}
          />
      </li>
    ));
  };
  return !loading ? (
    showsList.length > 0 ? (
      <div id="shows">
        <div className="wrapper">
          <h1 className="heading">{data?.category_name}</h1>
          <ul>{listShows()}</ul>
          <div className={downArrow ? "bottom" : "no-active"}>
            <div
              className={downArrow ? "downArrowContainer" : "no-active"}
              onClick={loadMore}
            >
              <img
                src={require("../../../assets/images/down-arrow-flat.png")}
                alt="Down-arrow"
              />
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "150px",
          color: "white",
        }}
      >
        No shows found!!
      </div>
    )
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "150px",
      }}
    >
      <Spinner />
    </div>
  );
}

export default ShowsScreen;
